import { debugHighlight, debugTags } from "@incendium/inc-ts-helpers";
import { useIframeContext } from "features/smartIFrame/providers/OldIframeProvider";
import { useSmartIframeContext } from "features/smartIFrame/providers/SmartIFrameProvider";
import { useEffect } from "react";
import { TextValidator } from "react-material-ui-form-validator";
import { useDebounce } from "react-use";

interface ICssSelectorProps {
  selector?: string;
  onChange: (v: string) => void;
}

function CssSelector({ selector, onChange }: ICssSelectorProps) {
  const { selectedSelector } = useIframeContext();
  const { sendMessage, iframeReadyVersion } = useSmartIframeContext();

  useEffect(() => {
    sendMessage({
      type: debugTags,
      data: ["*"],
    });
  }, [sendMessage, iframeReadyVersion]);

  useEffect(() => {
    return () => {
      sendMessage({
        type: debugTags,
        data: [],
      });
    };
  }, [sendMessage]);

  useEffect(() => {
    if (selectedSelector === "" || selectedSelector === selector) {
      return;
    }

    onChange(selectedSelector || "");
  }, [selectedSelector]);

  useDebounce(
    () => {
      sendMessage({
        type: debugHighlight,
        data: selector,
      });
    },
    500,
    [selector, sendMessage, iframeReadyVersion]
  );
  return (
    <TextValidator
      value={selector || ""}
      variant="outlined"
      name="selector"
      label="Selector"
      fullWidth
      validators={["required"]}
      errorMessages={["selector is required"]}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        onChange(e.target.value)
      }
    />
  );
}

export default CssSelector;
